
import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = '⚠ Name is required';
    if (!formData.email.trim()) newErrors.email = '⚠ Email is required';
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = '⚠ Invalid email format';
    if (!formData.message.trim()) newErrors.message = '⚠ Message cannot be empty';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      console.log('Form submitted:', formData);
      setSuccessMessage('✅ Thank you for reaching out! We will get back to you soon.');
      setFormData({ name: '', email: '', subject: '', message: '' });
    }
  };

  return (
    <div className="contact-container">
      <h2 className="contact-title">📩 Get in Touch</h2>
      <p className="contact-description">
        Have a question, a project idea, or just want to say hi? We’d love to hear from you!  
        Fill out the form below or contact us via email.
      </p>

      {/* Contact Info Section */}
      <div className="contact-info">
        <div className="contact-info-item">
          <h3>📍 Office Address</h3>
          <p>
            LogicBunny Technology Private Ltd.<br />
            #292 Anjanadri Complex, 5th Floor, 11th Block<br />
            Nagarabhavi, Bengaluru, Karnataka, 560072
          </p>
        </div>
        <div className="contact-info-item">
          <h3>📧 Email Us</h3>
          <p>
            <a href="mailto:info@logicbunny.in">info@logicbunny.in</a>
          </p>
        </div>
        <div className="contact-info-item">
          <h3>🌐 Follow Us</h3>
          <div className="social-icons">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">📘</a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">🐦</a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">🔗</a>
          </div>
        </div>
      </div>

      {/* Contact Form */}
      <form onSubmit={handleSubmit} className="contact-form">
        <div className="form-group">
          <label htmlFor="name">👤 Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className={errors.name ? 'input-error' : ''}
            placeholder="Enter your name"
          />
          {errors.name && <p className="error-message">{errors.name}</p>}
        </div>
        <div className="form-group">
          <label htmlFor="email">📧 Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className={errors.email ? 'input-error' : ''}
            placeholder="Enter your email"
          />
          {errors.email && <p className="error-message">{errors.email}</p>}
        </div>
        <div className="form-group">
          <label htmlFor="subject">📝 Subject</label>
          <input
            type="text"
            id="subject"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            placeholder="Subject (optional)"
          />
        </div>
        <div className="form-group">
          <label htmlFor="message">💬 Message</label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            className={errors.message ? 'input-error' : ''}
            placeholder="Write your message here..."
          ></textarea>
          {errors.message && <p className="error-message">{errors.message}</p>}
        </div>
        <button type="submit" className="submit-button">🚀 Send Message</button>
        {successMessage && <p className="success-message">{successMessage}</p>}
      </form>
    </div>
  );
};

export default Contact;
